import { useState } from 'react';

const navItems = [
  { key: '#top', label: '首页头版' },
  { key: '#categories', label: '吃瓜栏目' },
  { key: '#feed', label: '最新瓜田' },
  { key: '#timeline', label: '反转现场' },
  { key: '#review', label: '求真复盘' },
  { key: '#about', label: '关于我们' },
];

export default function TopNav() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-stone-200/80 bg-[#faf4ea]/90 backdrop-blur">
      <nav className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2.5" aria-label="校园反转社 首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-red-600 text-white">
            <i className="ri-newspaper-line text-lg" />
          </span>
          <span className="leading-tight">
            <span className="block font-editorial text-lg font-black tracking-wide text-stone-900">
              校园反转社
            </span>
            <span className="block text-[11px] font-medium text-stone-500">吃瓜·求证·追真相</span>
          </span>
        </a>

        <div className="hidden items-center gap-1 md:flex">
          {navItems.map((it) => (
            <a
              key={it.key}
              href={it.key}
              className="rounded-md px-3 py-2 text-sm font-medium text-stone-600 transition hover:bg-red-600/10 hover:text-red-700"
            >
              {it.label}
            </a>
          ))}
        </div>

        <div className="hidden items-center gap-3 md:flex">
          <a
            href="#contact"
            className="inline-flex items-center gap-1.5 rounded-md bg-red-600 px-4 py-2 text-sm font-medium text-white transition hover:bg-red-700"
          >
            <i className="ri-message-2-line text-[15px]" />
            <span className="whitespace-nowrap">爆料投稿</span>
          </a>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md border border-stone-200 text-stone-700 md:hidden"
        >
          <i className={`${open ? 'ri-close-line' : 'ri-menu-3-line'} text-xl`} />
        </button>
      </nav>

      {open && (
        <div className="border-t border-stone-200 bg-[#faf4ea] px-4 py-3 md:hidden">
          {navItems.map((it) => (
            <a
              key={it.key}
              href={it.key}
              onClick={() => setOpen(false)}
              className="block rounded-md px-3 py-2.5 text-sm font-medium text-stone-700 hover:bg-red-600/10"
            >
              {it.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={() => setOpen(false)}
            className="mt-2 flex items-center justify-center gap-1.5 rounded-md bg-red-600 px-4 py-2.5 text-sm font-medium text-white"
          >
            <i className="ri-message-2-line text-[15px]" /> 爆料投稿
          </a>
        </div>
      )}
    </header>
  );
}